import axios from '@/api/axios'
// import _ from 'lodash'

const apiUrlEx = '/v1/data'

const list = async (curPage, sdate, edate, sk, result) => {
  let finalData = {
    items: {},
    totalPage: 0
  }
  const options = {
    method: 'GET',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      page: curPage,
      sdate: sdate,
      edate: edate,
      sk: sk
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData.items = response.data.data
        finalData.totalPage = response.data.paginate.totalPage
        result(finalData)
      } else {
        result(null)
      }
    })

}

const makeExcel = async (carNum, id, sdate, edate, time, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/make_excel',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      id: id,
      sdate: sdate,
      edate: edate
    },
    responseType: 'blob',
    timeout: 60 * 2 * 1000 // 2min
  }

  await axios(options)
    .then((response) => {
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
        const link = document.createElement('a')
        const fileName = `${carNum}_${id}_${sdate}_${edate}_${time}.xlsx`
        // const contentDisposition = response.headers['content-disposition'] // 파일 이름
        // let fileName = 'unknown'
        // if (contentDisposition) {
        //   const [fileNameMatch] = contentDisposition.split(';').filter(str => str.includes('filename'))
        //   if (fileNameMatch)
        //     [, fileName] = fileNameMatch.split('=')
        // }
        // console.log(fileName)
        link.href = url
        link.setAttribute('download', `${fileName}`)
        link.style.cssText = 'display:none'
        document.body.appendChild(link)
        link.click()
        link.remove()
        result(true)
      } else {
        result(false)
      }
    }).catch(error => {
      console.log(error)
      result(false)
    })
}

const excelList = async (id, sdate, edate, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/excel-list',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      id: id,
      sdate: sdate,
      edate: edate
    }
  }

  await axios(options)
    .then((response) => {
      if (response.status === 200) {
        result(response.data.data)
      } else {
        result(null)
      }
    }).catch(error => {
      console.log(error)
      result(null)
    })
}
const excelDownload = async (carNum, id, sdate, edate, excels, result) => {
  const options = {
    method: 'POST',
    url: apiUrlEx + '/excel-download',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: {
      excels: excels
    },
    responseType: 'blob',
    timeout: 60 * 2 * 1000 // 2min
  }

  await axios(options)
    .then((response) => {
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
        const link = document.createElement('a')
        const fileName = `${carNum}_${id}_${sdate}_${edate}.zip`
        // const contentDisposition = response.headers['content-disposition'] // 파일 이름
        // let fileName = 'unknown'
        // if (contentDisposition) {
        //   const [fileNameMatch] = contentDisposition.split(';').filter(str => str.includes('filename'))
        //   if (fileNameMatch)
        //     [, fileName] = fileNameMatch.split('=')
        // }
        // console.log(fileName)
        link.href = url
        link.setAttribute('download', `${fileName}`)
        link.style.cssText = 'display:none'
        document.body.appendChild(link)
        link.click()
        link.remove()
        result(true)
      } else {
        result(false)
      }
    }).catch(error => {
      console.log(error)
      result(false)
    })
}

const data = async (curPage, sk, id, sdate, edate, result) => {
  let finalData = {
    items: {},
    totalPage: 0
  }
  const options = {
    method: 'GET',
    url: apiUrlEx + '/data',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      page: curPage,
      id: id,
      sdate: sdate,
      edate: edate,
      sk: sk
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData.items = response.data.data
        finalData.totalPage = response.data.paginate.totalPage
        result(finalData)
      } else {
        result(null)
      }
    })

}

export default {
  list,
  makeExcel,
  excelList,
  excelDownload,
  data
}

export {}
